module.exports = __webpack_public_path__ + "fonts/Montserrat-400-vietnamese8.05f0125.woff2";